export default "__VITE_ASSET__2TCvRf9g__"